/**
 * The entities the editor's own serialization writes, which is what put them
 * there: a line read out of an already written PM was escaped on the way into
 * that document. `&nbsp;` comes along because an editor's paste can leave one
 * behind, and it is a space rather than a word once the markup is gone.
 */
const ENTITIES: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: '\'',
  '#39': '\'',
  '#x27': '\'',
  nbsp: ' '
}

/**
 * The plain text of a memo block, whose `data.text` is html - what an inserted
 * PM's blocks arrive as. Markup a memo line has no room for is dropped rather
 * than shown; the block itself is carried along untouched, so nothing is lost
 * from the document that gets saved.
 *
 * Whitespace is collapsed, so a line written across two of them reads as one.
 */
export function plainText(html: string): string {
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&([a-z]+|#\d+|#x[0-9a-f]+);/gi, (entity, name: string) => (
      ENTITIES[name.toLowerCase()] ?? entity
    ))
    .replace(/\s+/g, ' ')
    .trim()
}
